// 画面レイアウト
import header from '@/components/organisms/TheHeader'
import footer from '@/components/organisms/TheFooter'
import sidebar from '@/components/organisms/TheSidebar'

// ------------------------------------------------------------
// 管理画面
// ------------------------------------------------------------
// 管理画面：設定状況
import Admin from '@/components/pages/admin/Index'
// 管理画面：運営からのお知らせ
import Announcement from '@/components/pages/admin/announcement/Index'
import AnnouncementDetail from '@/components/pages/admin/announcement/Detail'
// 管理画面：ユーザー管理
import User from '@/components/pages/admin/user/Index'
import UserList from '@/components/pages/admin/user/List'
import UserEdit from '@/components/pages/admin/user/Edit'
import UserExport from '@/components/pages/admin/user/Export'
import UserImport from '@/components/pages/admin/user/Import'
// 管理画面：ユーザー情報変更不可設定
import UserSetting from '@/components/pages/admin/envsettings/UserSetting'
// 管理画面：組織管理
import Group from '@/components/pages/admin/group/Index'
import GroupList from '@/components/pages/admin/group/List'
import GroupEdit from '@/components/pages/admin/group/Edit'
import GroupExport from '@/components/pages/admin/group/Export'
import GroupImport from '@/components/pages/admin/group/Import'
// 管理画面：共有タグ
import Mgtag from '@/components/pages/admin/mgtag/Index'
import MgtagList from '@/components/pages/admin/mgtag/List'
import MgtagEdit from '@/components/pages/admin/mgtag/Edit'
// 管理画面：きっかけ
import Extrigger from '@/components/pages/admin/extrigger/Index'
import ExtriggerList from '@/components/pages/admin/extrigger/List'
import ExtriggerEdit from '@/components/pages/admin/extrigger/Edit'
// 管理画面：交換場所
import Exlocation from '@/components/pages/admin/exlocation/Index'
import ExlocationList from '@/components/pages/admin/exlocation/List'
import ExlocationEdit from '@/components/pages/admin/exlocation/Edit'
// 管理画面：人物拡張項目管理 Ph.4は不要
// import Extracolumn from '@/components/pages/admin/extracolumn/Index'
// import ExtracolumnList from '@/components/pages/admin/extracolumn/List'
// import ExtracolumnEdit from '@/components/pages/admin/extracolumn/Edit'
// 管理画面：修正サービスの利用設定
import InputProxySettings from '@/components/pages/admin/envsettings/InputProxySettings'
// 管理画面：お知らせの設定
import InfoSettings from '@/components/pages/admin/envsettings/InfoSettings'
// 管理画面：パスワードポリシー
import Passwordpolicy from '@/components/pages/admin/envsettings/Passwordpolicy'
// 管理画面：添付ファイルサイズ設定
import AttachsizeSetting from '@/components/pages/admin/envsettings/AttachsizeSetting'
// 管理画面：データの保存期間設定
import ExpireSetting from '@/components/pages/admin/envsettings/ExpireSetting'
// 管理画面：ライセンス情報
import LicenseSetting from '@/components/pages/admin/envsettings/LicenseSetting'
// 管理画面：モバイルログイン設定
import MbloginSetting from '@/components/pages/admin/envsettings/MbLoginSetting'
// 管理画面：操作ログ設定
import AccessLog from '@/components/pages/admin/accesslog/Index'
import AccessLogList from '@/components/pages/admin/accesslog/List'
import AccessLogDetails from '@/components/pages/admin/accesslog/Details'
// 管理画面：SFA連携設定
import NISFAIntegrationSettings from '@/components/pages/admin/envsettings/NisfaIntegrationSettings'

// ------------------------------------------------------------
// 管理画面 isAdminPage: true
// ------------------------------------------------------------
export default [
  // システム管理者画面
  {
    path: '/admin',
    name: 'admin',
    meta: {
      isAdminPage: true
    },
    components: {
      header,
      sidebar,
      footer,
      content: Admin
    }
  },
  // お知らせ一覧
  {
    path: '/admin/announcements',
    meta: {
      isAdminPage: true
    },
    components: {
      header,
      sidebar,
      footer,
      content: Announcement
    },
    children: [
      // 詳細画面
      {
        path: ':id',
        name: 'announcement-detail',
        component: AnnouncementDetail,
        props: true // $route.params.idをpropsに引き渡す
      }
    ]
  },
  // ユーザー管理
  {
    path: '/admin/users',
    // Named Route 'user' has a default child route. When navigating to this named route (:to="{name: 'user'"), the default child route will not be rendered. Remove the name from this route and use the name of the default child route for named links instead.
    // name: 'user',
    meta: {
      isAdminPage: true
    },
    components: {
      header,
      sidebar,
      footer,
      content: User
    },
    children: [
      // 一覧画面
      {
        path: '',
        name: 'user',
        component: UserList,
        props: true // $route.params.idをpropsに引き渡す
      },
      // 作成画面
      {
        path: 'add',
        name: 'user-add',
        meta: {
          isReloadGuardPage: true
        },
        component: UserEdit,
        props: true // $route.params.idをpropsに引き渡す
      },
      // 変更画面
      {
        path: ':id/edit',
        name: 'user-edit',
        meta: {
          isReloadGuardPage: true
        },
        component: UserEdit,
        props: true // $route.params.idをpropsに引き渡す
      },
      // ユーザー情報のエクスポート
      {
        path: 'export',
        name: 'user-export',
        meta: {
          isReloadGuardPage: true
        },
        component: UserExport
      },
      // ユーザー情報のインポート
      {
        path: 'import',
        name: 'user-import',
        meta: {
          isReloadGuardPage: true
        },
        component: UserImport
      }
    ]
  },
  // ユーザー情報変更不可設定
  {
    path: '/admin/user-setting',
    name: 'user-setting',
    meta: {
      isAdminPage: true,
      isReloadGuardPage: true
    },
    components: {
      header,
      sidebar,
      footer,
      content: UserSetting
    }
  },
  // 組織管理
  {
    path: '/admin/groups',
    meta: {
      isAdminPage: true
    },
    components: {
      header,
      sidebar,
      footer,
      content: Group
    },
    children: [
      // 一覧画面
      {
        path: '',
        name: 'group',
        component: GroupList,
        props: true // $route.params.idをpropsに引き渡す
      },
      // 作成画面
      {
        path: 'add',
        name: 'group-add',
        meta: {
          isReloadGuardPage: true
        },
        component: GroupEdit,
        props: true // $route.params.idをpropsに引き渡す
      },
      // 変更画面
      {
        path: ':id/edit',
        name: 'group-edit',
        meta: {
          isReloadGuardPage: true
        },
        component: GroupEdit,
        props: true // $route.params.idをpropsに引き渡す
      },
      // 組織情報のエクスポート
      {
        path: 'export',
        name: 'group-export',
        meta: {
          isReloadGuardPage: true
        },
        component: GroupExport
      },
      // 組織情報のインポート
      {
        path: 'import',
        name: 'group-import',
        meta: {
          isReloadGuardPage: true
        },
        component: GroupImport
      }
    ]
  },
  // タグ管理
  {
    path: '/admin/mgtags',
    meta: {
      isAdminPage: true
    },
    components: {
      header,
      sidebar,
      footer,
      content: Mgtag
    },
    children: [
      // 一覧画面
      {
        path: '',
        name: 'mgtag',
        component: MgtagList
      },
      // 作成画面
      {
        path: 'add',
        name: 'mgtag-add',
        meta: {
          isReloadGuardPage: true
        },
        component: MgtagEdit
      },
      // 変更画面
      {
        path: ':id/edit',
        name: 'mgtag-edit',
        meta: {
          isReloadGuardPage: true
        },
        component: MgtagEdit,
        props: true // $route.params.idをpropsに引き渡す
      }
    ]
  },
  // きっかけ管理
  {
    path: '/admin/extriggers',
    meta: {
      isAdminPage: true
    },
    components: {
      header,
      sidebar,
      footer,
      content: Extrigger
    },
    children: [
      // 一覧画面
      {
        path: '',
        name: 'extrigger',
        component: ExtriggerList
      },
      // 作成画面
      {
        path: 'add',
        name: 'extrigger-add',
        meta: {
          isReloadGuardPage: true
        },
        component: ExtriggerEdit
      },
      // 変更画面
      {
        path: ':id/edit',
        name: 'extrigger-edit',
        meta: {
          isReloadGuardPage: true
        },
        component: ExtriggerEdit,
        props: true // $route.params.idをpropsに引き渡す
      }
    ]
  },
  // 交換場所管理
  {
    path: '/admin/exlocations',
    meta: {
      isAdminPage: true
    },
    components: {
      header,
      sidebar,
      footer,
      content: Exlocation
    },
    children: [
      // 一覧画面
      {
        path: '',
        name: 'exlocation',
        component: ExlocationList
      },
      // 作成画面
      {
        path: 'add',
        name: 'exlocation-add',
        meta: {
          isReloadGuardPage: true
        },
        component: ExlocationEdit
      },
      // 変更画面
      {
        path: ':id/edit',
        name: 'exlocation-edit',
        meta: {
          isReloadGuardPage: true
        },
        component: ExlocationEdit,
        props: true // $route.params.idをpropsに引き渡す
      }
    ]
  },
  // // 人物拡張項目管理 Ph.4は不要
  // {
  //   path: '/admin/extracolumns',
  //   meta: {
  //     isAdminPage: true
  //   },
  //   components: {
  //     header,
  //     sidebar,
  //     footer,
  //     content: Extracolumn
  //   },
  //   children: [
  //     // 一覧画面
  //     {
  //       path: '',
  //       name: 'extracolumn',
  //       component: ExtracolumnList
  //     },
  //     // 作成画面
  //     {
  //       path: 'add',
  //       name: 'extracolumn-add',
  //       meta: {
  //         isReloadGuardPage: true
  //       },
  //       component: ExtracolumnEdit
  //     },
  //     // 変更画面
  //     {
  //       path: ':id/edit',
  //       name: 'extracolumn-edit',
  //       meta: {
  //         isReloadGuardPage: true
  //       },
  //       component: ExtracolumnEdit,
  //       props: true // $route.params.idをpropsに引き渡す
  //     }
  //   ]
  // },
  // 修正サービスの利用設定
  {
    path: '/admin/input-proxy-settings',
    name: 'InputProxySettings',
    meta: {
      isAdminPage: true,
      isReloadGuardPage: true
    },
    components: {
      header,
      sidebar,
      footer,
      content: InputProxySettings
    }
  },
  // お知らせの設定
  {
    path: '/admin/info-settings',
    name: 'InfoSettings',
    meta: {
      isAdminPage: true,
      isReloadGuardPage: true
    },
    components: {
      header,
      sidebar,
      footer,
      content: InfoSettings
    }
  },
  // パスワードポリシー
  {
    path: '/admin/password-policy-settings',
    name: 'Passwordpolicy',
    meta: {
      isAdminPage: true,
      isReloadGuardPage: true
    },
    components: {
      header,
      sidebar,
      footer,
      content: Passwordpolicy
    }
  },
  // 添付ファイルサイズ設定
  {
    path: '/admin/attachment-size-settings',
    name: 'AttachsizeSetting',
    meta: {
      isAdminPage: true,
      isReloadGuardPage: true
    },
    components: {
      header,
      sidebar,
      footer,
      content: AttachsizeSetting
    }
  },
  // データの保存期間設定
  {
    path: '/admin/expiration-settings',
    meta: {
      isAdminPage: true,
      isReloadGuardPage: true
    },
    name: 'ExpireSetting',
    components: {
      header,
      sidebar,
      footer,
      content: ExpireSetting
    }
  },
  // ライセンス情報
  {
    path: '/admin/license-settings',
    meta: {
      isAdminPage: true
    },
    name: 'LicenseSetting',
    components: {
      header,
      sidebar,
      footer,
      content: LicenseSetting
    }
  },
  // モバイルログイン設定
  {
    path: '/admin/mobile-login-settings',
    meta: {
      isAdminPage: true,
      isReloadGuardPage: true
    },
    name: 'MbLoginSetting',
    components: {
      header,
      sidebar,
      footer,
      content: MbloginSetting
    }
  },
  // 操作ログ設定
  {
    path: '/admin/access-logs',
    meta: {
      isAdminPage: true,
      isReloadGuardPage: true
    },
    components: {
      header,
      sidebar,
      footer,
      content: AccessLog
    },
    children: [
      {
        path: '',
        name: 'AccessLog',
        component: AccessLogList
      },
      {
        path: ':id',
        name: 'AccessLogDetails',
        component: AccessLogDetails,
        props: true // $route.params.idをpropsに引き渡す
      }
    ]
  },
  // Sales Force Assistant 連携
  {
    path: '/admin/nisfa-integration-settings',
    meta: {
      isAdminPage: true,
      isReloadGuardPage: true
    },
    name: 'NISFAIntegrationSettings',
    components: {
      header,
      sidebar,
      footer,
      content: NISFAIntegrationSettings
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.sysset.js